export const AllSeasons = {
    "data": [
        {
            "id": 1,
            "version": 1,
            "season_name": "Season 1.1",
            "name": "Heroes of Reach",
            "description": "Because of you, we found Halo, unlocked its secrets, shattered our enemy's resolve.",
            "narrative_blurb": "",
            "image_urls": {
                "season_logo": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoic2Vhc29ucy9pbnNpZ25pYV9zMV9SQ0hfNTEyLnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D",
                "card_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU3dpdGNoZXIvT3BzX1N3aXRjaGVyX1MxX1JDSC5wbmciLCJvcHRpb25zIjp7fX0%3D",
                "battlepass_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU2NyZWVuQmFja2dyb3VuZHMvc2Vhc29uX3Vwc2VsbF9iYWNrZ3JvdW5kX1MxLnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D"
            },
            "properties": {
                "identifier": "Season1",
                "csr": "CsrSeason1"
            },
            "availability": [
                {
                    "start_date": "2021-06-20T17:00:00.000Z",
                    "end_date": "2022-05-03T17:00:00.000Z"
                }
            ]
        },
        {
            "id": 1,
            "version": 2,
            "season_name": "Season 1.2",
            "name": "Heroes of Reach",
            "description": "Because of you, we found Halo, unlocked its secrets, shattered our enemy's resolve.",
            "narrative_blurb": "",
            "image_urls": {
                "season_logo": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoic2Vhc29ucy9pbnNpZ25pYV9zMV9SQ0hfNTEyLnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D",
                "card_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU3dpdGNoZXIvT3BzX1N3aXRjaGVyX1MxX1JDSC5wbmciLCJvcHRpb25zIjp7fX0%3D",
                "battlepass_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU2NyZWVuQmFja2dyb3VuZHMvc2Vhc29uX3Vwc2VsbF9iYWNrZ3JvdW5kX1MxLnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D"
            },
            "properties": {
                "identifier": "Season1-2",
                "csr": "CsrSeason1-2"
            },
            "availability": [
                {
                    "start_date": "2021-06-20T17:00:00.000Z",
                    "end_date": "2022-05-03T17:00:00.000Z"
                }
            ]
        },
        {
            "id": 2,
            "version": 1,
            "season_name": "Season 2.1",
            "name": "Lone Wolves",
            "description": "A red carpet and unexpected guests.",
            "narrative_blurb": "Cortana’s dominion has ended, but the merciless forces of the Banished have rushed to fill the void, decimating all who stand in their way.\n\nSpartan Commander Agryna has enlisted a new generation of Spartans and is preparing them to face the Banished—and perhaps even more dangerous foes.\n\nBut a few scattered Spartans remain in the field. These Spartans are rugged and resourceful. Hunters in the dark. And they call themselves… Lone Wolves.",
            "image_urls": {
                "season_logo": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoic2Vhc29ucy9pbnNpZ25pYV9zMl9sb25ld29sdmVzXzUxMi5wbmciLCJvcHRpb25zIjp7fX0%3D",
                "card_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU3dpdGNoZXIvT3BzX1N3aXRjaGVyX1MyX0xXLnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D",
                "battlepass_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU2NyZWVuQmFja2dyb3VuZHMvc2Vhc29uX3Vwc2VsbF9iYWNrZ3JvdW5kLnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D"
            },
            "properties": {
                "identifier": "Season2",
                "csr": "CsrSeason2"
            },
            "availability": [
                {
                    "start_date": "2022-05-03T17:00:00.000Z",
                    "end_date": "2022-11-08T17:00:00.000Z"
                }
            ]
        },
        {
            "id": 2,
            "version": 2,
            "season_name": "Season 2.2",
            "name": "Winter Update",
            "description": "Drop into battle with sharp wits and even sharper knives.",
            "narrative_blurb": "Cortana’s dominion has ended, but the merciless forces of the Banished have rushed to fill the void, decimating all who stand in their way.\n\nSpartan Commander Agryna has enlisted a new generation of Spartans and is preparing them to face the Banished—and perhaps even more dangerous foes.\n\nBut a few scattered Spartans remain in the field. These Spartans are rugged and resourceful. Hunters in the dark. And they call themselves… Lone Wolves.",
            "image_urls": {
                "season_logo": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoic2Vhc29ucy9pbnNpZ25pYV9TMi01X1dVXzUxMi5wbmciLCJvcHRpb25zIjp7fX0%3D",
                "card_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU3dpdGNoZXIvT3BzX1N3aXRjaGVyX1MyLTVfV1UucG5nIiwib3B0aW9ucyI6e319",
                "battlepass_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU2NyZWVuQmFja2dyb3VuZHMvc2Vhc29uX3Vwc2VsbF9iYWNrZ3JvdW5kX1MyLTUucG5nIiwib3B0aW9ucyI6e319"
            },
            "properties": {
                "identifier": "Season-Winter-Break-22",
                "csr": "CsrSeason2-2"
            },
            "availability": [
                {
                    "start_date": "2022-11-08T17:00:00.000Z",
                    "end_date": "2023-03-07T17:00:00.000Z"
                }
            ]
        },
        {
            "id": 3,
            "version": 1,
            "season_name": "Season 3",
            "name": "Echoes Within",
            "description": "Sometimes our greatest challenges lie just beneath the surface.",
            "narrative_blurb": "Spartan Dinh picked up something dangerous in the field... Since returning to the Academy with Spartan Eklund, a Banished menace has haunted his dreams and memories, threatening to extend its reach.\n\nConfident they have contained the threat, Commander Agryna devotes herself to rebuilding the UNSC, training her Spartan recruits for the inevitable coming conflict with the Banished.\n\nStill, Dinh can't shake the feeling that something deeper is at play—and he needs your help. Time to burrow into the heart of the Academy and root out the source of the echoes within.",
            "image_urls": {
                "season_logo": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoic2Vhc29ucy9pbnNpZ25pYV9zM19FV181MTIucG5nIiwib3B0aW9ucyI6e319",
                "card_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU3dpdGNoZXIvT3BzX1N3aXRjaGVyX1MzX0VXLnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D",
                "battlepass_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU2NyZWVuQmFja2dyb3VuZHMvc2Vhc29uX3Vwc2VsbF9iYWNrZ3JvdW5kX1MzLnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D"
            },
            "properties": {
                "identifier": "Season3",
                "csr": "CsrSeason3-1"
            },
            "availability": [
                {
                    "start_date": "2023-03-07T17:00:00.000Z",
                    "end_date": "2023-06-20T17:00:00.000Z"
                }
            ]
        },
        {
            "id": 4,
            "version": 1,
            "season_name": "Season 4",
            "name": "Infection",
            "description": "The delicate line between friend and foe.",
            "narrative_blurb": "As Spartan Dinh grappled with the aftermath of his encounter with the Banished AI Iratus, he confirmed suspicions that something deeper was at play, and that Iratus was no longer as contained as once thought./n/nIratus has now infected the Academy systems, transforming their training simulations into a fight for survival as the Banished AI hijacks the Spartans’ Mjolnir armor to turn friend into foe./n/nThe Academy stands at the brink of collapse as the Spartans fight to contain the AI’s influence.",
            "image_urls": {
                "season_logo": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoic2Vhc29ucy9pbnNpZ25pYV9TNF9JTl8yNTYucG5nIiwib3B0aW9ucyI6e319",
                "card_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoiL3Byb2dyZXNzaW9uL1N3aXRjaGVyL09wc19Td2l0Y2hlcl9TNF9JTi5wbmciLCJvcHRpb25zIjp7fX0%3D",
                "battlepass_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU2NyZWVuQmFja2dyb3VuZHMvc2Vhc29uX3Vwc2VsbF9iYWNrZ3JvdW5kX1M0LnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D"
            },
            "properties": {
                "identifier": "Season4",
                "csr": "CsrSeason4-1"
            },
            "availability": [
                {
                    "start_date": "2023-06-20T17:00:00.000Z",
                    "end_date": "2023-10-17T17:00:00.000Z"
                }
            ]
        },
        {
            "id": 5,
            "version": 1,
            "season_name": "Season 5",
            "name": "Reckoning",
            "description": "Placeholder Short Description",
            "narrative_blurb": "Placeholder Long Description",
            "image_urls": {
                "season_logo": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoic2Vhc29ucy9pbnNpZ25pYV9zNV9SRUNfMjU2LnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D",
                "card_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU3dpdGNoZXIvU2Vhc29uX1N3aXRjaGVyX1M1X1JFQy5wbmciLCJvcHRpb25zIjp7fX0%3D",
                "battlepass_background": "https://blobs-infiniteugc.svc.halowaypoint.com/ugcstorage/playlist/96aedf55-1c7e-46d5-bdaf-19a1329fb95d/238fe5cb-5036-49d3-8962-615886147104/images/hero.jpg" //"https://blobs-infiniteugc.svc.halowaypoint.com/ugcstorage/playlist/4795cb47-5b32-4c87-98ab-02f12e94ca31/6ba2f14a-3861-4ad3-b645-57dd40c7295c/images/hero.jpg"
            },
            "properties": {
                "identifier": "Season5-Op1",
                "csr": "CsrSeason5-1"
            },
            "availability": [
                {
                    "start_date": "2023-10-17T17:00:00.000Z",
                    "end_date": "2023-11-14T17:00:00.000Z"
                }
            ]
        },
        {
            "id": 6,
            "version": 1,
            "season_name": "Season 6",
            "name": "Spirit of Fire",
            "description": "Placeholder Short Description",
            "narrative_blurb": "Placeholder Long Description",
            "image_urls": {
                "season_logo": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoic2Vhc29ucy9pbnNpZ25pYV9zNl9TT0ZfMjU2LnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D",
                "card_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU3dpdGNoZXIvU2Vhc29uX1N3aXRjaGVyX1M2X1NPRi5wbmciLCJvcHRpb25zIjp7fX0%3D",
                "battlepass_background": "https://blobs-infiniteugc.svc.halowaypoint.com/ugcstorage/playlist/78b10320-8bc4-491b-a3d5-80fa1ca847f8/7e4fc6d8-fee1-4f6f-bc02-01155c5e1e85/images/screenshot1.jpg"
            },
            "properties": {
                "identifier": "Season6-Op1",
                "csr": "CsrSeason6-1"
            },
            "availability": [
                {
                    "start_date": "2024-01-30T18:00:00.000Z",
                    "end_date": "2024-03-05T18:00:00.000Z"
                }
            ]
        },
        {
            "id": 7,
            "version": 1,
            "season_name": "Season 7",
            "name": "Banished Honor",
            "description": "Placeholder Short Description",
            "narrative_blurb": "Placeholder Long Description",
            "image_urls": {
                "season_logo": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoic2Vhc29ucy9pbnNpZ25pYV9zNl9TT0ZfMjU2LnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D",
                "card_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU3dpdGNoZXIvU2Vhc29uX1N3aXRjaGVyX1M2X1NPRi5wbmciLCJvcHRpb25zIjp7fX0%3D",
                "battlepass_background": "https://spartanrecord.com/images/Anvil.jpg" // "https://support.halowaypoint.com/hc/article_attachments/25945755760660"
            },
            "properties": {
                "identifier": "Season7-Op1",
                "csr": "CsrSeason7-1"
            },
            "availability": [
                {
                    "start_date": "2024-04-30T18:00:00.000Z",
                    "end_date": "2024-06-04T18:00:00.000Z"
                }
            ]
        },
        {
            "id": 8,
            "version": 1,
            "season_name": "Season 8",
            "name": "Fleetcom",
            "description": "Placeholder Short Description",
            "narrative_blurb": "Placeholder Long Description",
            "image_urls": {
                "season_logo": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoic2Vhc29ucy9pbnNpZ25pYV9zNl9TT0ZfMjU2LnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D",
                "card_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU3dpdGNoZXIvU2Vhc29uX1N3aXRjaGVyX1M2X1NPRi5wbmciLCJvcHRpb25zIjp7fX0%3D",
                "battlepass_background": "https://spartanrecord.com/images/Fleetcom.jpg" // "https://support.halowaypoint.com/hc/article_attachments/25945755760660"
            },
            "properties": {
                "identifier": "Season8-Op1",
                "csr": "CsrSeason8-1"
            },
            "availability": [
                {
                    "start_date": "2024-07-30T18:00:00.000Z",
                    "end_date": "2024-09-03T18:00:00.000Z"
                }
            ]
        },
        {
            "id": 9,
            "version": 1,
            "season_name": "Season 9",
            "name": "Great Journey",
            "description": "Placeholder Short Description",
            "narrative_blurb": "Placeholder Long Description",
            "image_urls": {
                "season_logo": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoic2Vhc29ucy9pbnNpZ25pYV9FdmVyZ3JlZW5fMjU2LnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D",
                "card_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU3dpdGNoZXIvU2Vhc29uX1N3aXRjaGVyX1M5X0gyQS5wbmciLCJvcHRpb25zIjp7fX0%3D",
                "challenges_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU2NyZWVuQmFja2dyb3VuZHMvY2hhbGxlbmdlc19iYWNrZ3JvdW5kLnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D",
                "battlepass_background": "https://wpassets.halowaypoint.com/wp-content/2024/11/OperationGreatJourney.jpg",
                "storefront_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU2NyZWVuQmFja2dyb3VuZHMvc3RvcmVmcm9udF9iYWNrZ3JvdW5kLnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D"
            },
            "properties": {
                "identifier": "Season9-Op1",
                "csr": "CsrSeason9-1"
            },
            "availability": [
                {
                    "start_date": "2024-11-05T18:00:00.000Z",
                    "end_date": "2024-12-03T18:00:00.000Z"
                }
            ]
        },
        {
            "id": 10,
            "version": 1,
            "season_name": "Season 10",
            "name": "Frontlines",
            "description": "Placeholder Short Description",
            "narrative_blurb": "Placeholder Long Description",
            "image_urls": {
                "season_logo": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoic2Vhc29ucy9pbnNpZ25pYV9FdmVyZ3JlZW5fMjU2LnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D",
                "card_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU3dpdGNoZXIvU2Vhc29uX1N3aXRjaGVyX1MxMF9Gcm9udGxpbmVzLnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D",
                "challenges_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU2NyZWVuQmFja2dyb3VuZHMvY2hhbGxlbmdlc19iYWNrZ3JvdW5kLnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D",
                "battlepass_background": "https://wpassets.halowaypoint.com/wp-content/2025/01/AST_Switcher_Frontline_1920x1080_CLEAN.jpg",
                "storefront_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU2NyZWVuQmFja2dyb3VuZHMvc3RvcmVmcm9udF9iYWNrZ3JvdW5kLnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D"
            },
            "properties": {
                "identifier": "Season10-Op1",
                "csr": "CsrSeason10-1"
            },
            "availability": [
                {
                    "start_date": "2025-02-04T18:00:00.000Z",
                    "end_date": "2025-03-11T18:00:00.000Z"
                }
            ]
        },
        {
            "id": 11,
            "version": 1,
            "season_name": "Season 11",
            "name": "Last Stand",
            "description": "Placeholder Short Description",
            "narrative_blurb": "Placeholder Long Description",
            "image_urls": {
                "season_logo": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoic2Vhc29ucy9pbnNpZ25pYV9FdmVyZ3JlZW5fMjU2LnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D",
                "card_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU3dpdGNoZXIvU2Vhc29uX1N3aXRjaGVyX1MxMV9MUy5wbmciLCJvcHRpb25zIjp7fX0%3D",
                "challenges_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU2NyZWVuQmFja2dyb3VuZHMvY2hhbGxlbmdlc19iYWNrZ3JvdW5kLnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D",
                "battlepass_background": "https://wpassets.halowaypoint.com/wp-content/2025/05/Last_Stand_PK-91.jpg",
                "storefront_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU2NyZWVuQmFja2dyb3VuZHMvc3RvcmVmcm9udF9iYWNrZ3JvdW5kLnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D"
            },
            "properties": {
                "identifier": "Season11-Op1",
                "csr": "CsrSeason11-1"
            },
            "availability": [
                {
                    "start_date": "2025-05-06T18:00:00.000Z",
                    "end_date": "2025-06-10T18:00:00.000Z"
                }
            ]
        },
        {
            "id": 12,
            "version": 1,
            "season_name": "Season 12",
            "name": "Shadows",
            "description": "Placeholder Short Description",
            "narrative_blurb": "Placeholder Long Description",
            "image_urls": {
                "season_logo": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoic2Vhc29ucy9pbnNpZ25pYV9FdmVyZ3JlZW5fMjU2LnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D",
                "card_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU3dpdGNoZXIvU2Vhc29uX1N3aXRjaGVyX1MxMV9MUy5wbmciLCJvcHRpb25zIjp7fX0%3D",
                "challenges_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU2NyZWVuQmFja2dyb3VuZHMvY2hhbGxlbmdlc19iYWNrZ3JvdW5kLnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D",
                "battlepass_background": "https://wpassets.halowaypoint.com/wp-content/2025/08/BanishedSlayer.jpg",
                "storefront_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU2NyZWVuQmFja2dyb3VuZHMvc3RvcmVmcm9udF9iYWNrZ3JvdW5kLnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D"
            },
            "properties": {
                "identifier": "Season12-Op1",
                "csr": "CsrSeason12-1"
            },
            "availability": [
                {
                    "start_date": "2025-08-05T18:00:00.000Z",
                    "end_date": "2025-09-09T18:00:00.000Z"
                }
            ]
        },
        {
            "id": 13,
            "version": 1,
            "season_name": "Infinite",
            "name": "Infinite",
            "description": "Placeholder Short Description",
            "narrative_blurb": "Placeholder Long Description",
            "image_urls": {
                "season_logo": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoic2Vhc29ucy9pbnNpZ25pYV9FdmVyZ3JlZW5fMjU2LnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D",
                "card_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU3dpdGNoZXIvU2Vhc29uX1N3aXRjaGVyX1MxM19JbmZpbml0ZS5wbmciLCJvcHRpb25zIjp7fX0%3D",
                "challenges_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU2NyZWVuQmFja2dyb3VuZHMvY2hhbGxlbmdlc19iYWNrZ3JvdW5kLnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D",
                "battlepass_background": "https://wpassets.halowaypoint.com/wp-content/2025/11/demon_117.jpg",
                "storefront_background": "https://grunt.api.dotapi.gg/games/halo-infinite/tooling/cms-images?hash=eyJpZGVudGlmaWVyIjoiaGkiLCJwYXRoIjoicHJvZ3Jlc3Npb24vU2NyZWVuQmFja2dyb3VuZHMvc3RvcmVmcm9udF9iYWNrZ3JvdW5kLnBuZyIsIm9wdGlvbnMiOnt9fQ%3D%3D"
            },
            "properties": {
                "identifier": "Season13-Op1",
                "csr": "CsrSeason13-1"
            },
            "availability": [
                {
                    "start_date": "2025-11-18T18:00:00.000Z",
                    "end_date": "2035-11-18T18:00:00.000Z"
                }
            ]
        }
    ],
    
    "additional": {
        "total": 13,
        "query": {
            "language": "en-US"
        }
    }
}